{
  "name": "@reactor-team/js-sdk",
  "version": "2.12.0",
  "description": "Reactor JavaScript frontend SDK — connect React and TypeScript apps to real-time AI video models on Reactor.",
  "license": "Apache-2.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/reactor-team/js-sdk.git"
  },
  "keywords": [
    "reactor",
    "sdk",
    "frontend",
    "react",
    "webrtc",
    "real-time",
    "video",
    "ai"
  ],
  "author": "Reactor Technologies, Inc.",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "sideEffects": false,
  "engines": {
    "node": ">=18"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE",
    "NOTICE"
  ],
  "scripts": {
    "prepack": "cp ../../LICENSE ../../NOTICE .",
    "postpack": "rm -f LICENSE NOTICE",
    "build": "tsup",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:unit": "vitest run __tests__/unit",
    "test:integration": "vitest run __tests__/integration",
    "format": "prettier --write .",
    "format:check": "prettier --check ."
  },
  "reactor": {
    "apiVersion": 1,
    "webrtcVersion": "1.0"
  },
  "packageManager": "pnpm@10.12.1",
  "dependencies": {
    "awaitqueue": "^3.3.0",
    "mp4box": "^2.3.0",
    "sdp-transform": "^3.0.0",
    "zod": "^4.4.3"
  },
  "peerDependencies": {
    "hls.js": "^1.6.0",
    "react": "^17.0.0 || ^18.0.0 || ^19.0.0",
    "zustand": "^5.0.6"
  },
  "peerDependenciesMeta": {
    "hls.js": {
      "optional": true
    }
  },
  "devDependencies": {
    "@roamhq/wrtc": "^0.8.0",
    "@types/node": "^25",
    "@types/react": "^19.2.15",
    "@types/sdp-transform": "^2.15.0",
    "hls.js": "^1.6.0",
    "prettier": "^3.6.2",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3",
    "vitest": "^4.1.7"
  }
}
